import React from 'react';
import './NoSearchResults.scss';

export const NoSearchResults: React.FC = () => {
  return <div className="noSearchResults">No search results</div>;
};
